export enum EntityType {
  services = 'services',
  spareParts = 'spareParts',
}
